<template>
  <div class="hidden-danger-content" @click="handleClick($event)">
    <vueSeamlessScroll
      v-if="eventList.length > 0"
      :data="eventList"
      :class-option="defaultOption"
      class="seamless-warp"
    >
      <div class="list" v-for="(item, index) in eventList" :key="index" :id="item.id" @click="sel(item)">
        <div class="li">
          {{ item.school_name }} {{ item.address }} 触发敏感词  {{item.keyword}}
        </div>
        <div class="sel">
          <div>{{ item.created_at }}</div>
          <span>
            事件类型:
            <template v-if="item.label == 0">没人处理</template>
            <template v-if="item.label == 1">玩闹</template>
            <template v-if="item.label == 2">谩骂冲突</template>
            <template v-if="item.label == 3">欺凌</template>
            <template v-if="item.label == 4">误报</template>
            <template v-if="item.label == 5">不确定</template>
          </span>
        </div>
      </div>
    </vueSeamlessScroll>
    <div v-else class="no-data">暂无数据</div>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  name: "hiddenDangerNow",
  components: {
    vueSeamlessScroll
  },
  props: {
    dataList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      eventList: [],
      resData: {},
      dialogVisible: false
    };
  },
  created() {},
  mounted() {},
  computed: {
    defaultOption() {
      return {
        step: 0.5, //步长 越大滚动速度越快
        limitMoveNum: 3, //启动无缝滚动最小数据量 this.dataList.length
        hoverStop: true, //是否启用鼠标hover控制
        direction: 1, //1 往上 0 往下
        openWatch: true, //开启data实时监听
        singleHeight: 0, //单条数据高度有值hoverStop关闭
        waitTime: 1000 //单步停止等待时间
      };
    }
  },
  watch: {
    dataList: function(newVal) {
      // console.log(newVal)
      if (newVal) {
        this.eventList = newVal;
      } else {
        this.eventList = [];
      }
    }
  },
  methods: {
    // async getHazardDetails(id) {
    //   let req = {
    //     id: id
    //   };
    //   let res = await this.$Http.hazardDetails(req);
    //   if (res.code == 200) {
    //     res.data.addTime = this.$Common.dateFormatDateTwo(res.data.addTime);
    //     this.resData = res.data;
    //     this.dialogVisible = true;
    //     console.log(res.data);
    //   } else if (res.code == 101) {
    //   } else {
    //   }
    // },
    handleClick(e){
      // console.log(e)
      // console.log(e.target.item)
        // let id = e.target.id
        // if (id) {
        //     this.getHazardDetails(id)
        // }
    },
    sel(item) {
      // console.log(item,111)
    }
  },
  destroyed() {}
};
</script>

<style lang="scss" scoped>
.hidden-danger-content {
  width: 89.74%;
  height: 220px;
  overflow-y: hidden;
  margin: 0 auto;

  .list {
    width: 100%;
    text-align: left;
    margin-bottom: 16px;
    &:nth-child(3n-2) {
      .li {
        background: url("~@/assets/img/eduBigData/list-bg-1.png") center center no-repeat;
        background-size: 100% 100%;
      }
    }
    &:nth-child(3n-1) {
      .li {
        background: url("~@/assets/img/eduBigData/list-bg-2.png") center center no-repeat;
        background-size: 100% 100%;
      }
    }
    &:nth-child(3n) {
      .li {
        background: url("~@/assets/img/eduBigData/list-bg-3.png") center center no-repeat;
        background-size: 100% 100%;
      }
    }
    .li {
      width: 100%;
      padding: 6px 16px;
      text-align: left;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #c9cbff;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: block;
      // cursor: pointer;
    }
    .sel {
      display: flex;
      justify-content: space-between;
      line-height: 1;
      padding: 0 16px;
      margin-top: 8px;
      div {
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(239, 250, 255, 0.6);
        line-height: 12px;
      }
      span {
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(239, 250, 255, 0.8);
        line-height: 12px;
        text-decoration: none;
        cursor: pointer;
      }
    }
  }
  .no-data {
    width: 100%;
    height: 220px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: rgba(255, 255, 255, 0.6);
  }
}
</style>
